import { useEffect, useRef } from 'react';
import { useOptionalFunnelContext } from '../funnel-provider';
import type {
  ComponentCapabilityHandler,
  ComponentSemanticActionType,
} from './component-capability-registry';

export function useSemanticComponentCapability(
  actionType: ComponentSemanticActionType,
  targetId: string,
  handler: ComponentCapabilityHandler,
): void {
  const funnel = useOptionalFunnelContext();
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!funnel) return undefined;
    return funnel.registerSemanticComponentCapability(
      actionType,
      targetId,
      (input, context) => handlerRef.current(input, context),
    );
  }, [actionType, funnel, targetId]);
}
